<template>
	<div class="container gpBGcolor text-white" style="margin-top:100px">
		<div class="well p-4">
			<h2 class="text-center mt-3">Games For Windows Phone</h2>
			<img src="../assets/fancy.png" class="img-fluid d-block mx-auto"/>

			<div class="row p-2 justify-content-between">
				<gameitem v-if="data.type=='phone' && data.genre=='action'" v-for="data in $options.gamedata.data" :key="data.id" v-bind:data="data"></gameitem>
			</div>

			<h4 class="text-center mt-3">Educational Games</h4>
			<div class="row p-2 justify-content-between">
				<gameitem v-if="data.type=='phone' && data.genre=='educational'" v-for="data in $options.gamedata.data" :key="data.id" v-bind:data="data"></gameitem>
			</div>
		</div>

		<div class="well mt-5 mb-5 p-4">
			<h2 class="text-center mt-3">Games For Windows</h2>
			<img src="../assets/fancy.png" class="img-fluid d-block mx-auto"/>

			<div class="row p-2 justify-content-center">
				<gameitem v-if="data.type=='win'" v-for="data in $options.gamedata.data" :key="data.id" v-bind:data="data"></gameitem>
			</div>
		</div>
	</div>
</template>

<script>
import gameitem from "./GameItem.vue";
import gamedata from "../assets/gamedata.json";

export default {
  components: { gameitem },
  gamedata: gamedata,
  created: function() {
    // console.log("GAMES CREATED");
    // console.log("PATH::" + this.$route.path);
    var fullname = this.$route.path;
    if (fullname.length > 1) {
      fullname = fullname
        .substring(1)
        .split("-")
        .join(" ");
      // console.log("WATCHED::" + fullname);
      this.$router.push({
        name: "detail",
        params: {
          gamename: fullname.split(" ").join("-")
          //   data: gamedata
        }
      });
    }
  },
};
</script>

<style scoped>
.well {
  border-radius: 15px;
  border: 1px solid rgb(39, 49, 71);
  background-color: #172131;
}

@media (max-width: 600px) {
  h2 {
    font-size: 1.5rem;
  }
}

a {
  color: white;
  text-decoration-line: none;
  transition: 0.2s ease-in-out;
}

a:hover {
  color: #f05f40;
}
</style>


// WEBPACK FOOTER //
// src/components/Games.vue